import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Session } from '../+state/session/session.model';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  public startSessionByDirectLink(directLink: string): Observable<Session> {
    const url: string = `${environment.alfredApiUrl}/api/sessions/questionnaire/${directLink}/start`;
    const headers: HttpHeaders = new HttpHeaders({
      accept: 'application/json',
    });

    return this.httpClient.get<Session>(url, {
      headers: headers,
    });
  }
}
